//Install
import React, { Component } from "react";

//Element
class H57G68 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB f029qa" },
            //Element
            React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q035zf" },
                //Element
                "03"
            ),
            //Element
            React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB g371o1" },
                //Element
                "Kimlere Hangi Hizmetler Sunuldu?"
            ),
            //Element
            React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB tv2821" },
                //Element
                "Geçmişten Bugüne",
                //Element
                React.createElement("br", {}),
                //Element
                React.createElement("em", {},
                    //Element
                    "Daimî"
                ),
                //Element
                React.createElement("br", {}),
                //Element
                "Başarılar"
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default H57G68;